module.exports = "<div class=\"content content-module\" id=\"content\">\n  <app-learn-structure></app-learn-structure>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/src/app/module/module.component.html
// module id = ../../../../../src/app/module/module.component.html
// module chunks = 1